import React from 'react';
import Icon from '../../../components/AppIcon';

const AppBranding = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex justify-center mb-4">
        <div className="w-16 h-16 lg:w-20 lg:h-20 bg-primary rounded-2xl flex items-center justify-center shadow-card">
          <Icon name="Users" size={32} color="white" className="lg:w-10 lg:h-10" />
        </div>
      </div>

      {/* App Name */}
      <h1 className="text-2xl lg:text-3xl font-bold text-text-primary mb-2">
        ContactSync Pro
      </h1>

      {/* Tagline */}
      <p className="text-text-secondary text-sm lg:text-base max-w-md mx-auto">
        Streamline your relationships with automated birthday wishes and smart contact management
      </p>
    </div>
  );
};

export default AppBranding;